import { SWITCH_TYPE, TEXT_TYPE } from "../../constants/webapp";

export const useVersionForm = () => {
  const fields = [
    {
      label: "version",
      type: TEXT_TYPE,
      required: true,
    },
    {
      label: "required",
      type: SWITCH_TYPE,
    },
  ];

  return { fields };
};
